<template lang='pug'>
v-col(sm='12')
  v-row(no-gutters)
    v-col(style='padding: 0 20px')
      md-card
        md-card-header.md-card-header-icon.md-card-header-green
          .card-icon
            md-icon connect_without_contact
          h4.title
            | {{ $t("webChannel.sessionControl.title") }}
        md-card-content
          form.form-horizontal(action method='post')
            .md-layout
              .md-layout-item(style='margin: auto;')
                | {{
                | $t(
                | "webChannel.sessionControl.subitems.enableInactivityWarning"
                | )
                | }}
              .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
              'text-success':\
              canalWebData.isExpirationWaringActive,\
              'text-danger': !canalWebData.isExpirationWaringActive\
              }")
                | {{
                | canalWebData.isExpirationWaringActive
                | ? $t("commonWords.enabled")
                | : $t("commonWords.disabled")
                | }}
              .md-layout-item.md-size-15
                md-switch(v-model='canalWebData.isExpirationWaringActive')
            .md-layout
              .md-layout-item(style='margin: auto;')
                | {{
                | $t(
                | "webChannel.sessionControl.subitems.enableSessionMaximumTime"
                | )
                | }}
              .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
              'text-success':\
              canalWebData.isTerminationActive,\
              'text-danger': !canalWebData.isTerminationActive\
              }")
                | {{
                | canalWebData.isTerminationActive
                | ? $t("commonWords.enabled")
                | : $t("commonWords.disabled")
                | }}
              .md-layout-item.md-size-15
                md-switch(v-model='\
                canalWebData.isTerminationActive\
                ')
            .md-layout
              md-field(style='margin-top: 30px' :class='idleWarningTimeClass')
                label
                  | {{
                  | $t(
                  | "webChannel.sessionControl.subitems.expirationWarning"
                  | )
                  | }}
                md-input(v-model='canalWebData.customerIdleWarningSeconds' type='number' :required='canalWebData.isExpirationWaringActive')
                span(class="md-error error-message" style='font-size: 10px; margin-bottom: 15px') {{idleWarningTimeErrorField}}
              md-field(style='margin-top: 20px' :class='idleTerminationTimeClass')
                label
                  | {{
                  | $t(
                  | "webChannel.sessionControl.subitems.sessionTimeout"
                  | )
                  | }}
                md-input(v-model='canalWebData.customerIdleTerminationSeconds' type='number' :required='canalWebData.isTerminationActive')
                span(class="md-error error-message" style='font-size: 10px; margin-bottom: 15px') {{idleTerminationTimeErrorField}}
              md-field(style='margin-top: 20px' :class='idleWarningMessageClass')
                label
                  | {{
                  | $t(
                  | "webChannel.sessionControl.subitems.expirationWarningMessage"
                  | )
                  | }}
                md-input(v-model='canalWebData.idleWarningMessage' :required='canalWebData.isExpirationWaringActive' style='padding: 0px;')
                span(class="md-error error-message" style='font-size: 10px; margin-bottom: 15px') {{$t('sessionControl.requiredField')}}
              md-field(style='margin-top: 20px' :class='idleTerminationMessageClass')
                label
                  | {{
                  | $t(
                  | "webChannel.sessionControl.subitems.goodbye"
                  | )
                  | }}
                md-input(v-model='canalWebData.idleTerminationMessage' :required='canalWebData.isTerminationActive')
                span(class="md-error error-message" style='font-size: 10px; margin-bottom: 15px') {{$t('sessionControl.requiredField')}}
              v-col.textarea-container
                p {{$t('sessionControl.userExitControlMessageList')}}
                p.font-12 {{$t('sessionControl.userExitControlMessageListSubtext')}}
                v-textarea(v-model='userExitControlMessageList' auto-grow)

</template>

<script>
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isExpirationWaringActive: true, // (Habilitar Aviso de inatividade)
      hasMaxSessionTime: true,
      hasMaxDisconnectionTime: true,
      expirationWarning: 43200, // (Aviso Expirar)
      sessionTimeout: 86400, // (Finaliza sessão)
      expirationWarningMessage: this.$t('sessionControl.forOurConversationNotToEndAutomatically'),
      goodbye: this.$t('sessionControl.thankYouForUsingOurServicesIEndedOurConversationDueToInactivity'),
      userExitControlMessageList: Array.isArray(this.canalWebData.userExitControlMessageList)
        ? this.canalWebData.userExitControlMessageList.join('\n')
        : this.canalWebData.userExitControlMessageList ?? ''
    }
  },
  computed: {
    idleWarningMessageClass () {
      return {
        'md-invalid': this.canalWebData.isExpirationWaringActive === true && this.canalWebData.idleWarningMessage.length === 0
      }
    },
    idleWarningTimeClass () {
      return {
        'md-invalid': this.missingIdleWarningTime || this.invalidIdleTerminationAndWarningTime
      }
    },
    idleTerminationMessageClass () {
      return {
        'md-invalid': this.canalWebData.isTerminationActive === true && this.canalWebData.idleTerminationMessage.length === 0
      }
    },
    missingIdleTerminationTime () {
      return this.canalWebData.isTerminationActive === true && this.canalWebData.customerIdleTerminationSeconds <= 0
    },
    missingIdleWarningTime () {
      return this.canalWebData.isExpirationWaringActive === true && this.canalWebData.customerIdleWarningSeconds <= 0
    },
    invalidIdleTerminationAndWarningTime () {
      return this.canalWebData.isTerminationActive &&
          this.canalWebData.isExpirationWaringActive &&
          parseInt(this.canalWebData.customerIdleWarningSeconds) + 10 > parseInt(this.canalWebData.customerIdleTerminationSeconds)
    },
    idleTerminationTimeClass () {
      return {
        'md-invalid': this.missingIdleTerminationTime || this.invalidIdleTerminationAndWarningTime
      }
    },
    idleTerminationTimeErrorField () {
      if (this.missingIdleTerminationTime) {
        return this.$t('sessionControl.requiredField')
      } else if (this.invalidIdleTerminationAndWarningTime) {
        return this.$t('sessionControl.maximumSessionTimeMustBeGreaterThanInactivityWarningTimeByAtLeastTenSeconds')
      }
      return ''
    },
    idleWarningTimeErrorField () {
      if (this.missingIdleWarningTime) {
        return this.$t('sessionControl.requiredField')
      } else if (this.invalidIdleTerminationAndWarningTime) {
        return this.$t('sessionControl.inactivityWarningTimeMustBeLessThanMaximumSessionTimeByAtLeastTenSeconds')
      }
      return ''
    }
  },
  methods: {
  },
  watch: {
    userExitControlMessageList (nV) {
      this.canalWebData.userExitControlMessageList = nV.split('\n')
    }
  }
}
</script>

<style scoped>
.textarea-container {
  margin-top: 20px;
  padding: 0;
}
.error-message {
  font-size: 10px;
  margin-bottom: 15px
}
.font-12{
  font-size: 12px;
}
</style>
